// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".contact-page[data-v-47c07011]{padding-left:1.2rem;padding-right:1.2rem;margin-left:auto;margin-right:auto;max-width:97.5rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
